module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "24px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "upload"
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.upload')))])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-right": "16px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('div', {}, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "classs": "''"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {}, [_c('el-select', {
    staticStyle: {
      "width": "calc(100% - 18px)"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.selectType),
      callback: function($$v) {
        _vm.selectType = $$v
      },
      expression: "selectType"
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "padding-right": "24px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.tgmccz'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.focusEvent(_vm.handleIconClick)
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('lin_global.name'),
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#8492A6"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitOne')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#F7BA2A"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitTwo')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "#13CE66"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyPass')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyNotPass')))]) : _vm._e(), _vm._v(" "), (scope.row.ifInfor) ? _c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.auditContent))]), _vm._v(" "), _c('span', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.ifInfor) ? _c('el-icon', {
          staticStyle: {
            "cursor": "pointer",
            "color": "#58B7FF"
          },
          attrs: {
            "name": "information"
          }
        }) : _vm._e()], 1)]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('terminal.details.animatType'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.otaUdType(scope.row.updateType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": _vm.$t('app_fileSize'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "md5",
      "label": "MD5",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "download",
      "label": _vm.$t('lin_global.downNumber'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "label": _vm.$t('lin_global.ope'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.smVerify'),
            "placement": "top"
          }
        }, [(scope.row.submit) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.edit'),
            "placement": "top"
          }
        }, [(scope.row.edit) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.delete'),
            "placement": "top"
          }
        }, [(scope.row.delete) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteRow(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7aed2a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/romList.vue
// module id = 1125
// module chunks = 0